import React from 'react';

import {
  Box,
  Stack,
  styled,
  Typography
} from '@mui/material';
import {
  ExternalLink,
  imageUtil,
  ResponsiveImage
} from 'modules';



const ButtonBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center'
});

const DescriptionTypography = styled(Typography)(({ theme }) => ({
  color: '#486c82',
  fontSize: 20
}));

const LogoContainerBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: theme.spacing(8)
}));

const LogoBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 145,
  maxWidth: 291,
  minWidth: 240
});

const ContainerBox = styled(Box)(({ theme }) => ({
  width: '95%',
  textAlign: 'center',
  marginTop: theme.spacing(16),
  marginBottom: theme.spacing(8)
}));



export const FC: React.FC = () => {
  const cooleyLogo = imageUtil.getUrlSet('cooley_logo', 'png');
  const choateLogo = imageUtil.getUrlSet('choate_logo', 'png');
  const dlaPiperLogo = imageUtil.getUrlSet('dla_piper_logo', 'png');
  const perkinsCoieLogo = imageUtil.getUrlSet('perkins_coie_logo', 'png');

  return (
    <ContainerBox>
      <DescriptionTypography>
        Ridge's content does not constitute legal advice, so you should consult legal counsel. Check out a few law firms to get support on your fundraise.
      </DescriptionTypography>

      <LogoContainerBox>
        {__renderLogoBox(cooleyLogo, 'https://www.cooley.com/services/practice/venture-capital')}
        {__renderLogoBox(choateLogo, 'https://www.choate.com/practices/private-equityma/index.html')}
        {__renderLogoBox(dlaPiperLogo, 'https://www.dlapiper.com/en/us/services/corporate/emerging-growth-and-venture-capital/')}
        {__renderLogoBox(perkinsCoieLogo, 'https://www.perkinscoie.com/en/practices/corporate-law/emerging-companies-venture-capital-law/index.html')}
      </LogoContainerBox>
    </ContainerBox>
  );
};



function __renderLogoBox(logoUrlSet: string[], linkUrl: string) {
  return (
    <Stack spacing={5}>
      <LogoBox>
        <ResponsiveImage.FC
          width='240px'
          urlSet={logoUrlSet} />
      </LogoBox>

      <ButtonBox>
        <ExternalLink.Button href={linkUrl}>
          LEARN MORE
        </ExternalLink.Button>
      </ButtonBox>
    </Stack>
  );
}
